import { ReactNode } from 'react';
import { Alert, Container } from 'react-bootstrap';

interface Props {
    children: ReactNode;
}

/**
 * Renders an inline error message in a legible danger-styled Alert.
 *
 * The app's body inherits `color: white` from the dark-themed global styles
 * (see src/index.css), but the main app container has a light background.
 * That makes any bare text (e.g. `<>{errorMessage}</>`) render white-on-light
 * and effectively invisible. Use this component instead so the error is
 * actually readable.
 */
export default function ErrorMessageView({ children }: Props) {
    return (
        <Container className="pt-3">
            <Alert
                variant="danger"
                style={{
                    backgroundColor: '#f8d7da',
                    border: '1px solid #f5c2c7',
                    color: '#842029',
                }}
            >
                {children}
            </Alert>
        </Container>
    );
}
